export enum DatabaseName {
  USERS = 'Users',
  TEAMS = 'Teams'
}

export enum UsersDatabaseColumnName {
  EMAIL = 'Email'
}

export enum TeamsDatabaseColumnName {
  TEAM_NAME = 'Team Name'
}
